import { useState } from 'react';
import { makeApiRequest, RequestStatus } from '../../api_request/api_request';
import { useAppDispatch } from '../../store/hooks';
import { Valid, RequestStatusDisplay } from '../CommonComponents';
import { Button, Input } from "../RequestRespectingInputs";
import { GetPageTitle } from '../../ErnotsConfig';
import { useLocation } from 'react-router-dom';

export function PasswordReset()
{
    const appDispatch = useAppDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const uid = searchParams.get('uid');
    const token = searchParams.get('token');

    const [new_password, setNewPassword] = useState<string>('');
    const [confirm_password, setConfirmPassword] = useState<string>('');

    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>)
    {
        e.preventDefault();
        if (new_password !== confirm_password)
        {
            return;
        }
        
        const userData = {uid, token, new_password};
        makeApiRequest({
            endpoint: 'users/reset_password_confirm/',
            method: 'POST',
            postData: userData,
            dispatch: appDispatch,
            lifeCycleCallback: setRequest,
            useAuthPrefix: true
        });
    }

    const ret = (
        <div>
            <h2>Reset Password</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="new-password">New Password:</label>
                    <Input
                        type="password"
                        id="new-password"
                        value={new_password}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                    <Valid bValid={new_password.trim()} children='A password is required.'/>
                </div>
                <div>
                    <label htmlFor="confirm-password">Confirm New Password:</label>
                    <Input
                        type="password"
                        id="confirm-password"
                        value={confirm_password}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                    <Valid bValid={new_password !== confirm_password} children="The confirmation password doesn't match."/>
                </div>
                <Button type='submit'>Reset Password</Button>
            </form>
            <RequestStatusDisplay request={request}/>
        </div>
    );

    return (
    <div className='ernots_User ernots_PasswordReset'>
        <title>{GetPageTitle('Password Reset')}</title>
        {ret}
    </div>);
};